import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import { useSelector } from "react-redux";
import GetMyPlansApi from "../../api/plans/GetMyPlansApi";
import { LIMIT_PER_PAGE } from "../../helpers/constants";
import { GetPlanTemplatesApi } from "../../api/plan-templates/GetPlanTemplatesApi";
import { Tabs } from "antd";
import TabPane from "antd/lib/tabs/TabPane";
import PageLoader from "../../components/sub/PageLoader";
import { WarningOutlined } from "@ant-design/icons";
import MyPlanTreeCards from "../../components/MyPlanTreeCard";
import { useLocation } from "react-router-dom";
import { getPluralString } from "../../helpers/wordHelpers";

export default function MyPlans() {
  const [data, setData] = useState([]);
  const [planCount, setPlanCount] = useState(0);
  const [canStart, setCanStart] = useState(false);
  const [canShowTab, setCanShowTab] = useState(false);
  const [page, setPage] = useState(1);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const proHeight = document.body.clientHeight;
  const curLocation = useLocation();
  const dataLength = data ? data.length : 0;
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    getTemplates();
  }, [perfCycleState, curLocation]);

  useEffect(() => {
    const defaultActiveKey = sortedPlanLevels?.[0]?.id || "";
    setActiveTab(defaultActiveKey);
  }, [templates]);

  useEffect(() => {
    if (activeTab) {
      setLoading(true);
      getMyPlanDetails(1, true, activeTab);
    }
  }, [activeTab]);

  async function getTemplates() {
    const apiResponse = await GetPlanTemplatesApi();
    if (apiResponse.success) {
      setTemplates(apiResponse.data);
      setCanStart(true);
      setCanShowTab(true);
    }
  }

  const selectedTemplate = templates?.find(
    (template) => template.id === perfCycleState.template
  );

  const sortedPlanLevels = selectedTemplate?.planLevels.sort(
    (a, b) => a.order - b.order
  );

  async function getMyPlanDetails(num, newSet, planLevelId) {
    setTableLoading(true);
    const apiResponse = await GetMyPlansApi(
      perfCycleState.id,
      planLevelId,
      num,
      LIMIT_PER_PAGE,
      positionState?.id
    );
    if (apiResponse.success) {
      if (newSet) {
        setData(apiResponse.data?.plans);
        setPlanCount(apiResponse.data?.totalCount);
      } else {
        setData([...data, ...apiResponse.data?.plans]);
      }
      setPage(num);
    }
    setTableLoading(false);
    setLoading(false);
  }

  function loadMore(num) {
    getMyPlanDetails(num, false, activeTab);
  }

  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);
    const selectedPlanLevel = selectedTemplate?.planLevels.find(
      (planLevel) => planLevel.id === activeKey
    );
    if (selectedPlanLevel) {
      getMyPlanDetails(1, selectedPlanLevel.id);
    }
  };

  function showEmptyPlans() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            Currently You Don't Have any Plans under this Performance Cycle!
          </div>
        </div>
      </div>
    );
  }

  const left = <div className="pri-font text-lg">My Plans</div>;

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          {canStart ? (
            sortedPlanLevels ? (
              canShowTab ? (
                <Tabs
                  defaultActiveKey={activeTab}
                  centered
                  onChange={handleTabChange}
                  activeKey={activeTab}
                  tabBarGutter={60}
                >
                  {sortedPlanLevels.map((planLevel) => (
                    <TabPane tab={planLevel.name} key={planLevel.id}>
                      <div className="mb-8">
                        {!loading ? (
                          dataLength > 0 ? (
                            <MyPlanTreeCards
                              data={data}
                              page={page}
                              loading={tableLoading}
                              loadMore={(num) => loadMore(num)}
                              setPage={(num) => setPage(num)}
                              planCount={planCount}
                            />
                          ) : (
                            <div className="flex justify-center items-center w-full h-full">
                              <div className="text-center">
                                <div className="text-3xl text-gray-400">
                                  <WarningOutlined />
                                </div>
                                <div className="text-xl pri-font text-gray-400">
                                  No {getPluralString(planLevel.name)} available
                                </div>
                              </div>
                            </div>
                          )
                        ) : (
                          <PageLoader />
                        )}
                      </div>
                    </TabPane>
                  ))}
                </Tabs>
              ) : (
                showEmptyPlans()
              )
            ) : (
              showEmptyPlans()
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
    </>
  );
}
